/* prettier-ignore */
/* eslint-disable */

// import type { ElegantConstRoute } from '@soybean-react/vite-plugin-react-router';
import type { RouteObject } from 'react-router-dom';

import { errors, fallbacks, layouts, pages } from './imports';
import { Navigate } from 'react-router-dom';


/**
* transform elegant const routes to react routes
*
* @param routes elegant const routes
* @param layouts layout components
* @param views view components
*/
// export function transformElegantRoutesToReactRoutes(routes: ElegantConstRoute[]) {
export function transformElegantRoutesToReactRoutes(routes: any[]) {
  return routes.flatMap(route => transformElegantRouteToReactRoute(null, route));
}


const concatPath = (prefix: string | undefined | null, path: string | null | undefined) => {
  if (!path) path = ''
  if (prefix) {
    prefix = prefix.endsWith("/") ? prefix.slice(0, -1) : prefix;
    path = path.startsWith("/") ? path.slice(1) : path;
    return prefix + "/" + path;
  } else {
    return path
  }
}

/**
* transform elegant route to react route
*
* @param route elegant const route
* @param layouts layout components
* @param views view components
*/
// export function transformElegantRouteToReactRoute(route: ElegantConstRoute): RouteObject {
export function transformElegantRouteToReactRoute(parent: any, route: any): RouteObject {
  const ROUTE_DEGREE_SPLITTER = '_';

  function isRouteGroup(name: string) {
    const lastName = name.split(ROUTE_DEGREE_SPLITTER).at(-1);
    return lastName?.startsWith('(') && lastName?.endsWith(')');
  }

  const {
    children,
    name,
    handle,
    fallback,
    errorBoundary,
    component, redirect,
    type, // M. 目录 C.菜单 A.按钮
    path
  } = route;
  const fullPath = concatPath(parent?.fullPath, path)

  const getErrorComponent = errors[errorBoundary || 'default'];

  // Convert route config, simplifying the logic for actions, loader, etc.
  function convertConfig(m: any) {
    const { action, loader, shouldRevalidate, default: Component } = m;
    return {
      action, // always use action
      loader, // always use loader
      shouldRevalidate,
      Component
    };
  }

  // Get config for the route if available
  async function getConfig() {
    if (component) {
      const config = await (type === 'M' ? layouts[component]() : pages[concatPath("/src/pages", component + ".tsx")]());
      return convertConfig(config);
    }

    //  let pageName = name;

    //  if (pageName==='notFound') {
    //        pageName = '404'
    //  };

    // if (component && (!children?.length || index)) {
    //   //  const config = await views[pageName]();
    //   const config = await resolvePage(component);

    //   return convertConfig(config);
    // }

    return null;
  }

  function getHandle() {
    // if ((type === 1 || isRouteGroup(name))) {
    //   return null
    // }

    return handle
  }
  const reactRoute = {
    HydrateFallback: fallbacks[fallback || 'default'],
    id: name,
    handle: getHandle(),
    lazy: async () => {
      const ErrorBoundary = await getErrorComponent();

      return {
        ErrorBoundary: ErrorBoundary?.default,
        ...(await getConfig())
      };
    },
    fullPath,
    children: [],
  } as RouteObject;

  if (path) {
    reactRoute.path = path
  }

  if (children?.length) {
    //  reactRoute.children = children.flatMap(child => transformElegantRouteToReactRoute(child));
    reactRoute.children = children.flatMap((child: any) => transformElegantRouteToReactRoute(reactRoute, child));

    if (redirect) {
      //  reactRoute.children.unshift({
      (reactRoute.children as any[]).unshift({
        index: true,
        handle: {},
        Component: () =>
          <Navigate
            replace
            to={redirect}
          />
      });
    }
  }

  return reactRoute;
}
